import NetworkLite from "@/types/NetworkLite";
import TrainingInstitutionLite from "@/types/TrainingInstitutionLite";

export class CourseShared {
    
    id!: number;
    title!: string;
    provider!: TrainingInstitutionLite;
    venueCity!: string;
    venueCountry!: string;
    network!: NetworkLite;
    dateFrom!: Date;
    dateTo!: Date;
    deadline!: Date;
    overallAim!: string;
    preRequisites!: string;
    applicationUrl!: string;


    public static fromResponse(data: any): CourseShared {

        const result: CourseShared = new CourseShared();

        if (data.id != undefined) {
            result.id = data.id;
        }

        if (data.title != undefined) {
            result.title = data.title;
        }

        if (data.dateFrom != undefined) {
            result.dateFrom = new Date(data.dateFrom);
        }

        if (data.dateTo != undefined) {
            result.dateTo = new Date(data.dateTo);
        }

        if (data.deadline != undefined) {
            result.deadline = new Date(data.deadline);
        }

        if (data.network != undefined) {
            result.network = NetworkLite.fromResponse(data.network);
        }

        if (data.provider != undefined) {
            result.provider = TrainingInstitutionLite.fromResponse(data.provider);
        }

        if (data.venueCity != undefined) {
            result.venueCity = data.venueCity;
        }

        if (data.venueCountry != undefined) {
            result.venueCountry = data.venueCountry?.name;
        }

        if (data.overallAim != undefined) {
            result.overallAim = data.overallAim;
        }

        if (data.preRequisites != undefined) {
            result.preRequisites = data.preRequisites;
        }

        if (data.applicationUrl != undefined) {
            result.applicationUrl = data.applicationUrl;
        }

        return result;

    }
    
}